import { Grid, MenuItem } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";
import * as yup from "yup";

export const initialValues = {
    code: "",
    title: "",
    type: "",
    timeframe: "",
    unit: "",
    description: "",
    data_formula: "",
    data_related: "",
};

export const validationSchema = yup.object().shape({
    code: yup.string(),
    title: yup.string().required(),
    type: yup.string().required(),
    timeframe: yup.number().required(),
    unit: yup.string().required(),
    description: yup.string().nullable(),
    data_formula: yup.string().nullable(),
    data_related: yup.string().nullable(),
});

export default function KpiInformationForm(props) {
    const { typeOptions = [], timeframeOptions = [] } = props;

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Field component={TextField} name="title" label="ชื่อตัวชี้วัด" required={true} fullWidth />
            </Grid>
            <Grid item xs={12} md={6}>
                <Field component={TextField} name="code" label="รหัส" fullWidth />
            </Grid>
            <Grid item xs={12} md={6}>
                <Field
                    component={TextField}
                    name="type"
                    label="ประเภทตัวชี้วัด"
                    select={true}
                    required={true}
                    fullWidth
                >
                    {typeOptions?.map((option, index) => (
                        <MenuItem key={index} value={option.id}>
                            {option.title}
                        </MenuItem>
                    ))}
                </Field>
            </Grid>
            <Grid item xs={12} md={6}>
                <Field component={TextField} name="timeframe" label="กรอบเวลา" select={true} required={true} fullWidth>
                    {timeframeOptions?.map((option, index) => (
                        <MenuItem key={index} value={option.id}>
                            {option.title}
                        </MenuItem>
                    ))}
                </Field>
            </Grid>

            <Grid item xs={12} md={6}>
                <Field component={TextField} name="unit" label="หน่วยนับ" required={true} fullWidth />
            </Grid>

            <Grid item xs={12}>
                <Field component={TextField} name="description" label="คำอธิบาย" fullWidth multiline minRows={3} />
            </Grid>

            <Grid item xs={12}>
                <Field component={TextField} name="data_formula" label="วิธีการคำนวณ" fullWidth multiline minRows={3} />
            </Grid>

            <Grid item xs={12}>
                <Field
                    component={TextField}
                    name="data_related"
                    label="ข้อมูลที่เกี่ยวข้อง"
                    fullWidth
                    multiline
                    minRows={3}
                />
            </Grid>
        </Grid>
    );
}
